<template>
  <div>
    <!-- My account area start -->
    <div class="main-content shop-page-account">
      <div class="container">
        <div class="container block-page-login" style="margin: 32px 0;">
          <div id="primary">
            <h1 class="page-title">Account</h1>
            <div class="row">
              <div class="col-lg-auto col-xs-12 col-sm-4 col-md-3 col-lg-3">
                <div class="wrapper_tabcontent customer">
                  <router-link to="/my-account" class="btn btn--full account">
                    <i class="icon-check-circle"></i>Dashboard
                  </router-link>
                  <router-link to="/my-orders" class="btn btn--full checkout">
                    <i class="icon-check-circle"></i>My Orders
                  </router-link>
                  <h3><i class="icon-menu"></i>View Addresses</h3> 
                  <!-- <router-link class="btn btn--full view-address" to="/wishlist">
                    <i class="icon-heart"></i>View wishlist
                  </router-link> -->
                  <router-link to="/checkout" class="btn btn--full checkout">
                    <i class="icon-check-circle"></i>Check Out
                  </router-link>
                  <button @click="logout" class="btn btn-link">
                    <i class="icon-log-out"></i>Logout
                  </button>
                </div>
              </div>
              <div class="account-content col">
                
                <div class="account_details">
                  <h3>Account details:</h3>
                  <div class="table-res">
                    <table class="table">
                      <tbody>
                        <tr>
                          <td><span class="h3">Name:</span></td>
                          <td>{{ user.name }}</td>
                        </tr>
                        <tr>
                          <td><span class="h3">Country:</span></td>
                          <td>{{ user.country || 'Not provided' }}</td>
                        </tr>
                        <tr>
                          <td><span class="h3">E-mail:</span></td>
                          <td>{{ user.email }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- My account area end -->

    <!-- cta area start -->
    <cta-area></cta-area>
    <!-- cta area end -->
  </div>
</template>

<script>
import CtaArea from '@/components/cta/cta-area.vue'

export default {
  name: 'MyAccountPage',
  components: {
    CtaArea,
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')) || { name: 'Guest', email: '' },
    }
  },
  computed: {
    isLoggedIn() {
      return !!this.user
    },
  },
  methods: {
    async logout() {
      try {
        // Send logout request to the server
        const response = await this.$axios.post('/logout', {}, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('auth_token')}`,
          },
        })

        if (response.status === 200) {
          // Clear localStorage
          localStorage.removeItem('user')
          localStorage.removeItem('auth_token')

          // Redirect to login page
          //this.$router.push({ name: 'login' })
          window.location.href = '/login';
        } else {
          console.error('Logout failed:', response.data.message || 'Unknown error')
        }
      } catch (error) {
        console.error('Error during logout:', error.response?.data?.message || error.message)
      }
    },
  },
}
</script>

<style scoped>
/* Scoped styles here */
</style>


<style scoped>
/* Add any scoped CSS styles if required */
.shop-page-account h1.page-title {
  color: #222222;
  font-size: 38px;
  font-weight: 500;
  text-transform: uppercase;
  text-align: center;
  margin: 0 0 30px;
  line-height: 1;
  border-bottom: 2px solid #ebebeb;
  padding-bottom: 15px
}

.wrapper_tabcontent.customer h3 {
  height: 45px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  text-transform: uppercase;
  color: #fff;
  background-color: #222222;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  width: 100%;
  border-radius: 3px;
  border: 1px solid #222222;
  padding: 0 15px
}

.wrapper_tabcontent.customer .btn {
  height: 45px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  text-transform: uppercase;
  color: #222222;
  background-color: #f6f6f6;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ebebeb;
  padding: 0 15px
}

.wrapper_tabcontent.customer .btn:hover {
  border-color: var(--color-btn-hover);
  background-color: var(--color-btn-hover);
  color: var(--color-btn-text_hover)
}

.wrapper_tabcontent.customer h3 i,
.wrapper_tabcontent.customer .btn i {
  font-size: 17px;
  margin-right: 10px
}

.account-content p.title-customer {
  line-height: 45px;
  font-size: 14px;
  text-transform: capitalize
}

.account-content p.title-customer span {
  font-weight: 700;
  text-transform: capitalize;
  color: #222222
}

.account-content p.title-customer a {
  color: var(--color-hover);
  text-decoration: underline
}

.order-history {
  margin-bottom: 65px
}

.account_details h3,
.order-history h3 {
  color: #222222;
  margin: 0 0 10px;
  display: flex;
  position: relative;
  text-align: center;
  letter-spacing: -.03em;
  font-weight: 600;
  font-size: 18px;
  line-height: 45px
}

.order-history p.none {
  display: flex;
  align-items: center;
  height: 45px;
  margin-bottom: 10px
}

.order-history p.none a {
  display: flex;
  align-items: center;
  text-decoration: underline;
  margin-right: 10px
}

.order-history p.none a svg {
  margin-right: 10px
}

.table .h3 {
  color: #222222
}

.account_details .table-res .table {
  border: 1px solid #e5e5e5;
  border-bottom: none;
  border-right: none
}

.account_details .table-res .table td {
  border-right: 1px solid #e5e5e5
}

@media (max-width: 400px) {
  .order-history p.none {
    flex-direction: column
  }
}

h3,
.h3,
h4,
.h4 {
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0px;
}

td {
  padding: 10px;
  border-style: none;
  color: #4f4f4f !important;
  border-width: 0 1px 1px 0;
}

/*# sourceMappingURL=/cdn/shop/t/30/assets/customer.css.map?v=67239531929002166581678980254 */
</style>
